import { render, staticRenderFns } from "./TestimCard2.vue?vue&type=template&id=fe05b2f0&scoped=true&"
import script from "./TestimCard2.vue?vue&type=script&lang=js&"
export * from "./TestimCard2.vue?vue&type=script&lang=js&"
import style0 from "./TestimCard2.vue?vue&type=style&index=0&id=fe05b2f0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fe05b2f0",
  null
  
)

export default component.exports